import { DocumentListFilterFormData } from '@/models/documents/document-list-filter.model';

export const DEFAULT_DOCUMENT_LIST_FILTER_FORM_DATA: DocumentListFilterFormData = {
  countryList: [],
  countryListCondition: '',
  tagList: [],
  tagIdListCondition: '',
  segmentList: [],
  segmentIdListCondition: '',
  minTotalAmountEur: null,
  maxTotalAmountEur: null,
  moderationStatus: '',
};
